import { render } from "./Integration.vue?vue&type=template&id=801f19c4"
import script from "./Integration.vue?vue&type=script&lang=js"
export * from "./Integration.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__